// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"55b60dc8","93":"c8bcbfc9","121":"8e09760f","272":"72d6bf8a","304":"99726cff","336":"d62c3064","432":"c8842784","483":"a7230024","534":"c3ab0b25","650":"11e64c85","678":"aed1ace0","843":"0b069a7d","900":"e710b1d1","965":"6aaf5c4a"}[chunkId] + ".chunk.js";
};